import * as stylex from '@stylexjs/stylex'
import type { CSSProperties } from 'react'

const styles = stylex.create({
  s0: {
    height: "48px",
    width: "56px",
    flexShrink: "0",
  },
  s1: {
    fontSize: "29px",
    fontWeight: 700,
    letterSpacing: "-.035em",
    color: "#252525",
  },
  s2: {
    color: "#4f865c",
  },
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
})
type LogoProps = {
  className?: string
  style?: CSSProperties
}

export function WalletMark({ className = '', style }: LogoProps) {
  const markProps = stylex.props(styles.s0)

  return (
    <svg {...markProps} className={[markProps.className, className].filter(Boolean).join(' ') || undefined} style={{ ...markProps.style, ...style }} viewBox="0 0 72 64" aria-hidden="true">
      <path d="M13 16 50 4l5 15H13z" fill="#8daf88" />
      <path d="m19 12 28 7-4 12-28-7z" fill="#678d67" />
      <rect x="5" y="17" width="54" height="42" rx="7" fill="#8b5d31" />
      <path d="M5 25c0-4 3-7 7-7h41c4 0 6 3 6 7v5H5z" fill="#a77645" opacity=".5" />
      <rect x="42" y="30" width="25" height="18" rx="6" fill="#704621" />
      <rect x="45" y="32" width="20" height="14" rx="5" fill="#9a6a38" />
      <circle cx="51" cy="39" r="3" fill="#f7ead1" />
    </svg>
  )
}

export default function SettleUpLogo({ className = '', style }: LogoProps) {
  const logoProps = stylex.props(styles.root)

  return (
    <div {...logoProps} className={[logoProps.className, className].filter(Boolean).join(' ') || undefined} style={{ ...logoProps.style, ...style }} aria-label="SettleUp">
      <WalletMark {...stylex.props(styles.s0)} />
      <span {...stylex.props(styles.s1)}>
        Settle<span {...stylex.props(styles.s2)}>Up</span>
      </span>
    </div>
  )
}
